import DefaultViewManager from "../../../managers/default";
import {extend, defer, windowBounds, isNumber} from "../../../utils/core";
import { EVENTS } from "../../utils/constants";
import scrollType from "../../utils/scrolltype";

import ExMapping from "../../mapping";

import Hook from "../../utils/hook";
import ExStage from "../helpers/stage";
import ExViews from "../helpers/views";
import ExEpubCFI from "../../epubcfi";

class ExDefaultViewManager extends DefaultViewManager {
	constructor(options, rendition) {
		super(options);

		//加入ExEpubCFI
		this.epubcfi = new ExEpubCFI();

		//加入顯示器
		this.rendition = rendition;

		//加入書籍
		this.book = rendition.book;

		//加入當下顯示章節
		this.nowSection = options.section;

		//新增鉤子屬性
		this.hooks = {};
		this.hooks.afterIframeOnload = new Hook(this);

		//新增顯示器事件判斷目標 renditionEventTarget, 作為多重 view 顯示時的觸發指標
		this.finalEventTarget = null;

		//加入改變尺寸頻率過濾
		this._resizeTimeout = undefined;
		this._lastStageSizeCounter = null;
		this._lastStageSize = null;

		//多媒體是否為全屏播放模式
		this._isMediaFullScreen = false;

		//目前旋轉角度
		this._orientation = window.orientation;
		
		//結束全螢幕是否要resize
		this._isTriggerResizeAfterFullScreenEnd = false;

		//是否等待影片縮回後resize
		this._isWaitMediaScale = false;

		//最後捲動位置
		this._lastScrollPosition = null;

		//等待內容展開時間(向下相容)
		this._waitLayoutUpdateTime = 100;

		//內容縮放比例
		this._contentScale = 1;
		this._contentScrollLeft = 0;
		this._contentScrollTop = 0; 
		this.contentScaleRange = [1, 1.2, 1.4, 1.6, 1.8, 2, 3];
		this.contentScaleIndex = 0;
	}

	scrollBy(x, y, silent){
		let dir = this.settings.direction === "rtl" ? -1 : 1;

		if(silent) {
			this.ignore = true;
		}

		let scrollX, scrollY, fixScrollLeft, fixScrollTop, fixScrollLeftFloat, fixScrollTopFloat;

		let dist = (Math.abs(x) !== 0 ) ? Math.abs(x) : Math.abs(y);
		if(!this.settings.fullsize) {

			if(x){
				scrollX = x * dir;
				fixScrollLeft = Math.ceil(this.container.scrollLeft);
				fixScrollLeftFloat = fixScrollLeft%dist;
				if(fixScrollLeftFloat !== 0){
					if(fixScrollLeftFloat >= dist/2){
						fixScrollLeft = (Math.floor(fixScrollLeft/dist) + 1) * dist;
					}else{
						fixScrollLeft = Math.floor(fixScrollLeft/dist) * dist;
					}
				}
				this.container.scrollLeft = fixScrollLeft+scrollX;
			}

			if(y){
				scrollY = y;
				fixScrollTop = Math.ceil(this.container.scrollTop);
				fixScrollTopFloat = fixScrollTop%dist;
				if(fixScrollTopFloat !== 0){
					if(fixScrollTopFloat >= dist/2){
						fixScrollTop = (Math.floor(fixScrollTop/dist) + 1) * dist;
					}else{
						fixScrollTop = Math.floor(fixScrollTop/dist) * dist;
					}
				}
				this.container.scrollTop = fixScrollTop+scrollY;
			}

			//保存最後捲動位置
			this._lastScrollPosition = {
				x: this.container.scrollLeft,
				y: this.container.scrollTop
			}
		} else {
			scrollX = x * dir;
			scrollY = y * dir;
			window.scrollBy(scrollX, scrollY);
			//保存最後捲動位置
			this._lastScrollPosition = {
				x: window.pageXOffset,
				y: window.pageYOffset
			}
		}
		this.scrolled = true;
	}

	scrollTo(x, y, silent){
		if(silent) {
			this.ignore = true;
		}

		if(!this.settings.fullsize) {		
			this.container.scrollLeft = x;
			this.container.scrollTop = y;
			//保存最後捲動位置
			this._lastScrollPosition = {
				x: this.container.scrollLeft,
				y: this.container.scrollTop
			}
		} else {
			window.scrollTo(x,y);
			//保存最後捲動位置
			this._lastScrollPosition = {
				x: window.pageXOffset,
				y: window.pageYOffset
			}
		}
		this.scrolled = true;
	}

	onScroll(){
		
		//校正因text select而造成的棍動現象
		if(this.rendition.cancelAllScroll){
			if(!this.settings.fullsize) {		
				this.container.scrollLeft = this._lastScrollPosition.x;
				this.container.scrollTop = this._lastScrollPosition.y;
			} else {
				window.scrollTo(this._lastScrollPosition.x,this._lastScrollPosition.y);
			}
			return false;
		}


		let scrollTop;
		let scrollLeft;

		if(!this.settings.fullsize) {
			scrollTop = this.container.scrollTop;
			scrollLeft = this.container.scrollLeft;
		} else {
			scrollTop = window.scrollY;
			scrollLeft = window.scrollX;
		}

		this.scrollTop = scrollTop;
		this.scrollLeft = scrollLeft;
		if(!this.ignore) {
			if(!this.rendition.cancelRelocatedByScroll){
				this.emit(EVENTS.MANAGERS.SCROLL, {
					top: scrollTop,
					left: scrollLeft
				});
				clearTimeout(this.afterScrolled);
				this.afterScrolled = setTimeout(function () {
					this.emit(EVENTS.MANAGERS.SCROLLED, {
						top: this.scrollTop,
						left: this.scrollLeft
					});
				}.bind(this), 20);
			}else{
				this.rendition.cancelRelocatedByScroll = false;
			}
		} else {
			this.ignore = false;
		}

	}

	render(element, size){
		let tag = element.tagName;

		if (typeof this.settings.fullsize === "undefined" &&
				tag && (tag.toLowerCase() == "body" ||
				tag.toLowerCase() == "html")) {
			this.settings.fullsize = true;
		}

		if (this.settings.fullsize) {
			this.settings.overflow = "visible";
			this.overflow = this.settings.overflow;
		}

		this.settings.size = size;

		this.settings.rtlScrollType = scrollType();

		// Save the stage
		this.stage = new ExStage({
			width: size.width,
			height: size.height,
			overflow: this.overflow,
			hidden: this.settings.hidden,
			axis: this.settings.axis,
			fullsize: this.settings.fullsize,
			direction: this.settings.direction
		}, this.rendition);

		this.stage.attachTo(element);

		// Get this stage container div
		//this.container = this.stage.getContainer();

		// GEt this stage scaler div
		this.container = this.scaler = this.stage.getScaler();
		
		// Views array methods
		this.views = new ExViews(this.scaler, this.rendition);
		//this.views = new ExViews(this.container);

		// Calculate Stage Size
		this._bounds = this.bounds();
		this._stageSize = this.stage.size();

		// Set the dimensions for views
		this.viewSettings.width = this._stageSize.width;
		this.viewSettings.height = this._stageSize.height;

		// Function to handle a resize event.
		// Will only attach if width and height are both fixed.
		this.stage.onResize(this.onResized.bind(this));

		this.stage.onOrientationChange(this.onOrientationChange.bind(this));

		// Add Event Listeners
		this.addEventListeners();

		// Add Layout method
		// this.applyLayoutMethod();
		if (this.layout) {
			this.updateLayout();
		}

		this.rendered = true;

	}

	dragScaleContent(addScaleOriginX, addScaleOriginY){

		let contentTransform = this.stage.contentTransform();
		let prevContentScale = contentTransform.scale;
		let prevContentTranslateX = contentTransform.translateX;
		let prevContentTranslateY = contentTransform.translateY;
		let prevContentOriginX = contentTransform.originX;
		let prevContentOriginY = contentTransform.originY;

		let containerOffsetWidth = this.container.offsetWidth;
		let containerOffsetHeight = this.container.offsetHeight;
		let containerScrollTop = this.container.scrollTop;
		let containerScrollLeft = this.container.scrollLeft;
		let containerScrollWidth = this.container.scrollWidth;
		let containerScrollHeight = this.container.scrollHeight;

		let targetTranslateX, targetTranslateY;
		targetTranslateX = prevContentTranslateX + addScaleOriginX;
		targetTranslateY = prevContentTranslateY + addScaleOriginY;

		let maxTranslateX = prevContentOriginX * prevContentScale - prevContentOriginX;
		//let minTranslateX = maxTranslateX - ((containerScrollLeft + containerOffsetWidth) * prevContentScale - (containerScrollLeft + containerOffsetWidth));
		let minTranslateX = maxTranslateX - (containerOffsetWidth * prevContentScale - containerOffsetWidth);
		let maxTranslateY = prevContentOriginY * prevContentScale - prevContentOriginY;
		//let minTranslateY = maxTranslateY - ((containerScrollTop + containerOffsetHeight) * prevContentScale - (containerScrollTop + containerOffsetHeight));
		let minTranslateY = maxTranslateY - (containerOffsetHeight * prevContentScale - containerOffsetHeight);

		//捲動方向以scroll方式處理
		targetTranslateX = Math.max(minTranslateX, Math.min(targetTranslateX, maxTranslateX));
		targetTranslateY = Math.max(minTranslateY, Math.min(targetTranslateY, maxTranslateY));
		if(this.rendition.manager.name === 'continuous'){
			if(this.rendition.book.package.metadata.layout !== "pre-paginated" && this.rendition.manager.settings.axis === "horizontal"){
				let scrollLeftTaget = containerScrollLeft - addScaleOriginX;
				if(scrollLeftTaget < 0){
					this.stage.contentTransform({translateX:targetTranslateX, translateY:targetTranslateY});
				}else{
					this.stage.contentTransform({translateX:prevContentTranslateX, translateY:targetTranslateY});
					this.rendition.manager.scrollTo(scrollLeftTaget, containerScrollTop);
				}
			}else{
				let scrollTopTaget = containerScrollTop - addScaleOriginY;
				if(scrollTopTaget < 0 || scrollTopTaget > (containerScrollHeight - containerOffsetHeight)){
					this.stage.contentTransform({translateX:targetTranslateX, translateY:targetTranslateY});
				}else{
					this.stage.contentTransform({translateX:targetTranslateX, translateY:prevContentTranslateY});
					this.rendition.manager.scrollTo(containerScrollLeft, scrollTopTaget);
				}
			}
		}else{
			this.stage.contentTransform({translateX:targetTranslateX, translateY:targetTranslateY});
		}

		//targetTranslateX = Math.max(minTranslateX, Math.min(targetTranslateX, maxTranslateX));
		//targetTranslateY = Math.max(minTranslateY, Math.min(targetTranslateY, maxTranslateY));
		//this.stage.contentTransform({translateX:targetTranslateX, translateY:targetTranslateY});
	}

	scaleConetnt(scale, scaleOriginX = null, scaleOriginY = null, isWheelScale = true){
		let contentTransform = this.stage.contentTransform();
		let prevContentScale = contentTransform.scale;
		let prevContentTranslateX = contentTransform.translateX;
		let prevContentTranslateY = contentTransform.translateY;
		let prevContentOriginX = contentTransform.originX;
		let prevContentOriginY = contentTransform.originY;

		let containerScrollLeft = this.container.scrollLeft;
        let containerScrollTop = this.container.scrollTop;
		let containerOffsetWidth = this.container.offsetWidth;
		let containerOffsetHeight = this.container.offsetHeight;
		let containerOffsetLeft = this.container.offsetLeft;
		let containerOffsetTop = this.container.offsetTop;

		let targetScale = (isWheelScale) ? scale : Math.max(1, Math.min(prevContentScale + (scale - 1), 5));

		let targetOriginX, targetOriginY;
		if(scaleOriginX === null || scaleOriginY === null){
			targetOriginX = containerOffsetLeft + (containerOffsetWidth / 2);
			targetOriginY = containerOffsetTop + (containerOffsetHeight / 2);
		}else{
			targetOriginX = scaleOriginX - containerScrollLeft;
			targetOriginY = scaleOriginY - containerScrollTop;
		}
		//targetOriginX = Math.max(0, Math.min(targetOriginX, containerOffsetWidth));
		//targetOriginY = Math.max(0, Math.min(targetOriginY, containerOffsetHeight));

		let scalerBounds = this.stage.getScalerSize();
		let scalerWidth = scalerBounds.width/prevContentScale;
		let scalerHeight = scalerBounds.height/prevContentScale;
		

		let targetTranslateX = prevContentTranslateX + (prevContentOriginX - prevContentOriginX * prevContentScale) - (targetOriginX - targetOriginX * prevContentScale);
		let targetTranslateY = prevContentTranslateY + (prevContentOriginY - prevContentOriginY * prevContentScale) - (targetOriginY - targetOriginY * prevContentScale);
		let maxTranslateX = prevContentOriginX * scale - prevContentOriginX;
		//let minTranslateX = maxTranslateX - (containerOffsetWidth * scale - containerOffsetWidth);
		let minTranslateX = maxTranslateX - (scalerWidth * scale - scalerWidth);

		let maxTranslateY = prevContentOriginY * scale - prevContentOriginY;
		//let minTranslateY = maxTranslateY - (containerOffsetHeight * scale - containerOffsetHeight);
		let minTranslateY = maxTranslateY - (scalerHeight * scale - scalerHeight);

		targetTranslateX = Math.max(minTranslateX, Math.min(targetTranslateX, maxTranslateX));
		targetTranslateY = Math.max(minTranslateY, Math.min(targetTranslateY, maxTranslateY));

		this.stage.contentTransform({scale:targetScale, translateX:targetTranslateX, translateY:targetTranslateY}, targetOriginX, targetOriginY);
		this._contentScale = targetScale;
		this.emit(EVENTS.MANAGERS.CONTENT_SCALE, this._contentScale);
	}

	
	getContentScale(){
		return this._contentScale;
	}

	sleep(time){
		return(new Promise(function(resolve, reject) {
			setTimeout(function() { resolve(); }, time);
		}));
	}

	display(section, target){
		var displaying = new defer();
		var displayed = displaying.promise;

		// Check if moving to target is needed
		if (target === section.href || isNumber(target)) {
			target = undefined;
		}

		// Check to make sure the section we want isn't already shown
		var visible = this.views.find(section);

		// View is already shown, just move to correct location in view
		if(visible && section && this.layout.name !== "pre-paginated" && ( target && !this.epubcfi.isCpctString(target) )) {
			
			let offset = visible.offset();

			if (this.settings.direction === "ltr") {
				this.scrollTo(offset.left, offset.top, true);
			} else {
				let width = visible.width();
				this.scrollTo(offset.left + width, offset.top, true);
			}
			if(target) {
				let offset = visible.locationOf(target);
				let width = visible.width();
				if(offset){
					this.moveTo(offset, width);
					displaying.resolve();
				}
			}else{
				displaying.resolve();
			}

			return displayed;
		}
		
		//keep now section
		this.nowSection = section;
		
		// Hide all current views
		this.clear();

		//加入updateLayout
		this.updateLayout();

		let forceRight = false;
		if (this.layout.name === "pre-paginated" && this.layout.divisor === 2 && (section.properties.includes("page-spread-right") || section.properties.includes("rendition:page-spread-right"))) {
			forceRight = true;
		}

		//檢查是否有後繼頁面
		let flowSection = this.handleNextPrePaginated(forceRight, section, this.add, true);
		this.finalEventTarget = (flowSection) ? flowSection : section;

		//設定目前顯示章節
		if(!this.rendition.settings.isHidden){
			this.book.spine.each((sectionItem) => sectionItem.checkIsNowDisplay(section.index, this.finalEventTarget.index));
		}

		this.add(section, forceRight)
			.then(function(view){
				return this.hooks.afterIframeOnload.trigger(view.contents, this).then(()=>{
					return view;
				});
			}.bind(this))
			.then(function (view) {
				if(view.contents){
					//確認內容最後尺寸已就緒
					return view.contents.allContentOnloadCheck().then(() => {
						this.updateLayout();
						if(this.rendition._layout.name !== "pre-paginated"){
							return this.sleep(this._waitLayoutUpdateTime).then(()=>{
								return view.contents.finalSizeCheck().then(() => {
									return view;
								});
							});
						}else{
							return view.contents.finalSizeCheck().then(() => {
								view.setEmptyPage(view.contents._backgroundSize);
								return view;
							});
						}
					});
				}else{
					return view;
				}
            }.bind(this))
			.then(function (view) {
				//加入cpct轉cfi
				if(this.epubcfi.isCpctString(target)){
					let getCFI = this.book.locations.generateCFIFromCpct('epubjs-task-convent-open-point-cpct', target);
					if (getCFI && getCFI.then && typeof getCFI.then === "function") {
						return getCFI.then((cfi)=>{
							target = cfi;
							return view;
						});
					}else{
						target = getCFI;
						return view;
					}
				}else{
					return view;
				}
			}.bind(this))
			.then(function(view){	
				// Move to correct place within the section, if needed
				if(target) {
					let offset = view.locationOf(target);
					let width = view.width();
					if(offset){
						this.moveTo(offset, width);
					}
				}

			}.bind(this), (err) => {
				displaying.reject(err);
			})
			.then(function(){
				return this.handleNextPrePaginated(forceRight, section, this.add.bind(this));
			}.bind(this))
			.then(function(){
				this.views.show();
				displaying.resolve();
			}.bind(this));
		// .then(function(){
		// 	return this.hooks.display.trigger(view);
		// }.bind(this))
		// .then(function(){
		// 	this.views.show();
		// }.bind(this));
		return displayed;
	}

	spineDisplay(section){
		var displaying = new defer();
		var displayed = displaying.promise;

		//keep now section
		this.nowSection = section;

		// Hide all current views
		this.clear();

		//加入updateLayout
		this.updateLayout();

		let forceRight = false;
		if (this.layout.name === "pre-paginated" && this.layout.divisor === 2 && (section.properties.includes("page-spread-right") || section.properties.includes("rendition:page-spread-right"))) {
			forceRight = true;
		}

		//檢查是否有後繼頁面
		let flowSection = this.handleNextPrePaginated(forceRight, section, this.add, true);
		this.finalEventTarget = (flowSection) ? flowSection : section;

		//設定目前背景顯示章節
		if(this.rendition.taskData.task !== 'epubjs-task-convent-open-point-cpct'){
			this.book.spine.each((sectionItem) => sectionItem.checkIsBgNowDisplay(section.index, this.finalEventTarget.index));
		}

		this.add(section, forceRight)
			.then(function(view){
				return this.hooks.afterIframeOnload.trigger(view.contents, this).then(()=>{
					return view;
				});
			}.bind(this), (err) => {
				displaying.reject(err);
			})
			.then(function (view) {
                if(view && view.contents){
					//確認內容最後尺寸已就緒
					return view.contents.allContentOnloadCheck().then(() => {
						this.updateLayout();
						if(this.rendition._layout.name !== "pre-paginated"){
							return this.sleep(this._waitLayoutUpdateTime).then(()=>{
								return view.contents.finalSizeCheck().then(() => {
									return view;
								});
							});
						}else{
							return view.contents.finalSizeCheck().then(() => {
								view.setEmptyPage(view.contents._backgroundSize);
								return view;
							});
						}
					});
				}else{
					return view;
				}
            }.bind(this))
			.then(function(){
				return this.handleNextPrePaginated(forceRight, section, this.add);
			}.bind(this))
			.then(function(){
				//背景計算, 不需要顯示
				//this.views.show();
				displaying.resolve();
			}.bind(this));
		return displayed;
	}

	onOrientationChange(e) {
		let {orientation} = window;

		if(!this.isDocumentFullscreen()){

			//紀錄目前旋轉角度
			this._orientation = orientation;

			/*if(this.optsSettings.resizeOnOrientationChange) {
				this.resize();
			}*/

			// Per ampproject:
			// In IOS 10.3, the measured size of an element is incorrect if the
			// element size depends on window size directly and the measurement
			// happens in window.resize event. Adding a timeout for correct
			// measurement. See https://github.com/ampproject/amphtml/issues/8479
			clearTimeout(this.orientationTimeout);
			this.orientationTimeout = setTimeout(function(){
				this.orientationTimeout = undefined;

				if(this.optsSettings.resizeOnOrientationChange) {
					this.resize();
				}

				this.emit(EVENTS.MANAGERS.ORIENTATION_CHANGE, orientation);
			}.bind(this), 500);
		}else{
			let lastOrientationText = this.getOrientationText(this._orientation);
			let nowOrientationText = this.getOrientationText(orientation);
			this._isTriggerResizeAfterFullScreenEnd = (lastOrientationText !== nowOrientationText);
			//紀錄目前旋轉角度
			this._orientation = orientation;
		}
	}

	afterFullScreenResize(){
		let {orientation} = window;
		clearTimeout(this.orientationTimeout);
			this.orientationTimeout = setTimeout(function(){
				this.orientationTimeout = undefined;

				if(this.optsSettings.resizeOnOrientationChange) {
					this.resize();
				}

				this.emit(EVENTS.MANAGERS.ORIENTATION_CHANGE, orientation);
			}.bind(this), 500);
	}

	getOrientationText(orientation){
		let orientationText = null;
		switch(orientation){
            case 0:
            case 180: orientationText = 'portrait';
                      break;
            case 90:
            case -90: orientationText = 'landscape';
                      break;
        }
		return orientationText;
	}

	onResized(e) {
		if(!this.isDocumentFullscreen()){
			if(this._isWaitMediaScale){
				this._isWaitMediaScale = false;
				if(this._resizeTimeout){
					clearTimeout(this._resizeTimeout);
				}
				this._resizeTimeout = setTimeout(()=>{
					this.forceResize();
				}, 10);
			}else{
				this.resize();
			}
		}
	}

	isDocumentFullscreen(){
		let isFullScreen = false;
		if(this._isMediaFullScreen){
			isFullScreen = this._isMediaFullScreen;
		}else if(this.views){
			$.each(this.views._views, function(index, view){
				if(view && view.document){
					isFullScreen = (view.document.fullscreenElement && view.document.fullscreenElement !== null) ||
								(view.document.webkitFullscreenElement && view.document.webkitFullscreenElement !== null) ||
								(view.document.mozFullScreenElement && view.document.mozFullScreenElement !== null) ||
								(view.document.msFullscreenElement && view.document.msFullscreenElement !== null);
					if(isFullScreen){
						return false;
					}
				}
			});
		}
		
		return isFullScreen;
	}

	updateFlow(flow, defaultScrolledOverflow="auto"){
		let isPaginated = (flow === "paginated" || flow === "auto");

		this.isPaginated = isPaginated;

		if (flow === "scrolled-doc" ||
				flow === "scrolled-continuous" ||
				flow === "scrolled") {
			this.updateAxis("vertical");
		} else {
			this.updateAxis("horizontal");
		}

		this.viewSettings.flow = flow;

		if (!this.settings.overflow) {
			if(defaultScrolledOverflow === "auto"){
				this.overflow = isPaginated ? "hidden" : defaultScrolledOverflow;
			}else{
				this.overflow = defaultScrolledOverflow;
			}
		} else {
			this.overflow = this.settings.overflow;
		}

		this.stage && this.stage.overflow(this.overflow);

		this.updateLayout();

	}

	forceResize(width, height, epubcfi){
		let stageSize = this.stage.size(width, height);

		// For Safari, wait for orientation to catch up
		// if the window is a square
		this.winBounds = windowBounds();
		if (this.orientationTimeout &&
				this.winBounds.width === this.winBounds.height) {
			// reset the stage size for next resize
			this._stageSize = undefined;
			return;
		}

		this._stageSize = stageSize;

		this._bounds = this.bounds();

		// Clear current views
		this.clear();

		// Update for new views
		this.viewSettings.width = this._stageSize.width;
		this.viewSettings.height = this._stageSize.height;

		this.updateLayout();

		this._lastStageSize = {
			width: this._stageSize.width,
			height: this._stageSize.height
		};
		this.emit(EVENTS.MANAGERS.RESIZED, this._lastStageSize, epubcfi);

		//加入 resize display 觸發點
		clearTimeout(this._lastStageSizeCounter);
		this._lastStageSizeCounter = setTimeout(function(){
			clearTimeout(this._lastStageSizeCounter);
			this.checkResizeDisplay(epubcfi);			
		}.bind(this),1000);
	}

	resize(width, height, epubcfi){

		let stageSize = this.stage.size(width, height);

		// For Safari, wait for orientation to catch up
		// if the window is a square
		this.winBounds = windowBounds();
		if (this.orientationTimeout &&
				this.winBounds.width === this.winBounds.height) {
			// reset the stage size for next resize
			this._stageSize = undefined;
			return;
		}

		if (this._stageSize &&
				this._stageSize.width === stageSize.width &&
				this._stageSize.height === stageSize.height ) {
				// Size is the same, no need to resize
			return;
		}

		this._stageSize = stageSize;

		this._bounds = this.bounds();

		// Clear current views
		this.clear();

		// Update for new views
		this.viewSettings.width = this._stageSize.width;
		this.viewSettings.height = this._stageSize.height;

		this.updateLayout();

		this._lastStageSize = {
			width: this._stageSize.width,
			height: this._stageSize.height
		};
		this.emit(EVENTS.MANAGERS.RESIZED, this._lastStageSize, epubcfi);

		//加入 resize display 觸發點
		clearTimeout(this._lastStageSizeCounter);
		this._lastStageSizeCounter = setTimeout(function(){
			clearTimeout(this._lastStageSizeCounter);
			this.checkResizeDisplay(epubcfi);			
		}.bind(this),1000);
		
	}

	//判斷 resize display 事件
	checkResizeDisplay(epubcfi){
		let stageSize = this.stage.size();
		if(this._lastStageSize.width === stageSize.width && this._lastStageSize.height === stageSize.height){
			this._lastStageSize = null;
			this.emit(EVENTS.MANAGERS.RESIZED_DISPLAY, epubcfi);
		}
	}

	//加入isPreCheck參數, 便於提前檢查事是否有後繼頁面
	handleNextPrePaginated(forceRight, section, action, isPreCheck = false) {

		let flow;

		if (this.layout.name === "pre-paginated" && this.layout.divisor > 1) {

			if (/*section.index === 0 ||*/ section.properties.includes("page-spread-center") || section.properties.includes("rendition:page-spread-center") || section.properties.includes("page-spread-center-left") || section.properties.includes("page-spread-center-right")) {
				// First page (cover) and center page should stand alone for pre-paginated books
				return;
			}
			if(section.properties.includes("page-spread-right") || section.properties.includes("rendition:page-spread-right")){
				//目前已載入右側頁面
				if(this.rendition.settings.direction === "rtl"){
					//左翻書
					flow = section.next();
				}else{
					//右翻書
					flow = section.prev();
					action = this.prepend;
				}
				if(flow && !(flow.properties.includes("page-spread-left") || flow.properties.includes("rendition:page-spread-left"))){
					flow = undefined;
				}
			}else if(section.properties.includes("page-spread-left") || section.properties.includes("rendition:page-spread-left")){
				//目前已載入左側頁面
				if(this.rendition.settings.direction === "rtl"){
					//左翻書
					flow = section.prev();
					action = this.prepend;
				}else{
					//右翻書
					flow = section.next();
				}
				if(flow && !(flow.properties.includes("page-spread-right") || flow.properties.includes("rendition:page-spread-right"))){
					flow = undefined;
				}
			}
			
			if (flow && !flow.properties.includes("page-spread-center") && !flow.properties.includes("rendition:page-spread-center") && !flow.properties.includes("page-spread-center-left") && !flow.properties.includes("page-spread-center-right")) {
				if(isPreCheck){
					return flow;
				}else{
					//加入判斷, 以排除重複加入後繼頁面的問題
					let isAlreadyAddFlow = false;
					$.each(this.views._views, (index, alreadyAddSection) => {
						if(alreadyAddSection.index == flow.index) {
							isAlreadyAddFlow = true;
							return false;
						}
					});
					if(!isAlreadyAddFlow){
						return action.call(this, flow).then(function(view){
							return this.hooks.afterIframeOnload.trigger(view.contents, this).then(()=>{
								return view;
							});
						}.bind(this)).then(function (view) {
							if(view.contents){
								//確認內容最後尺寸已就緒
								return view.contents.allContentOnloadCheck().then(() => {
									this.updateLayout();
									if(this.rendition._layout.name !== "pre-paginated"){
										return this.sleep(this._waitLayoutUpdateTime).then(()=>{
											return view.contents.finalSizeCheck().then(() => {
												return view;
											});
										});
									}else{
										return view.contents.finalSizeCheck().then(() => {
											view.setEmptyPage(view.contents._backgroundSize);
											return view;
										});
									}
								});
							}else{
								return view;
							}
						}.bind(this));
					}else{
						return;
					}
					
				}
			}
		}else{
			if(isPreCheck){
				return null;
			}
		}
	}

	next(){
		var next;
		var left;

		let dir = this.settings.direction;

		if(!this.views.length) return;

		if(this.isPaginated && this.settings.axis === "horizontal" && (!dir || dir === "ltr")) {

			this.scrollLeft = this.container.scrollLeft;

			//android 有翻頁不準的情況, 所以用頁數的方式反推
			//left = this.container.scrollLeft + this.container.offsetWidth + this.layout.delta;
			left = this.getNextFixLeft();

            //float issue：
            //滿足scrollby但實際上捲不動->left無變動，無論幾次next都留在本spine的最後一頁
            //滿足scrollby且可以捲動->left最後達到scrollWidth, 表示要連按兩次才會進到下一個spine
            //console.log(`%c -- check left : ${left}, scrollWidth : ${this.container.scrollWidth}--`, 'background: gray; color: white');

			if(this.rendition._layout.name !== "pre-paginated" && left <= this.container.scrollWidth) {

				//float issue：
				//console.log(`%c -- trigger scrollby --`, 'background: gray; color: white');

				this.scrollBy(this.layout.delta, 0, true);
			} else {
				next = this.views.last().section.next();
			}
		} else if (this.isPaginated && this.settings.axis === "horizontal" && dir === "rtl") {
			
			this.scrollLeft = this.container.scrollLeft;

			if (this.settings.rtlScrollType === "default"){

				//android 有翻頁不準的情況, 所以用頁數的方式反推
				//left = this.container.scrollLeft;
				left = this.getNextFixLeft();

				if (this.rendition._layout.name !== "pre-paginated" && left > 0) {
					this.scrollBy(this.layout.delta, 0, true);
				} else {
					next = this.views.last().section.next();
				}
			} else {

				//android 有翻頁不準的情況, 所以用頁數的方式反推
				//left = this.container.scrollLeft + ( this.layout.delta * -1 );
				left = this.getNextFixLeft();

				//float issue：
				//console.log(`%c -- check left : ${left}, scrollWidth : ${this.container.scrollWidth * -1} --`, 'background: gray; color: white');
				if (this.rendition._layout.name !== "pre-paginated" && left > this.container.scrollWidth * -1){

					//float issue：
					//console.log(`%c -- trigger scrollby --`, 'background: gray; color: white');

					this.scrollBy(this.layout.delta, 0, true);
				} else {
					next = this.views.last().section.next();
				}
			}

		} else if (this.isPaginated && this.settings.axis === "vertical") {

			this.scrollTop = this.container.scrollTop;

			//android 有翻頁不準的情況, 所以用頁數的方式反推
			//let top  = this.container.scrollTop + this.container.offsetHeight;
			let top  = this.getNextFixTop();

			//float issue：
			//console.log(`%c -- check top : ${top}, scrollHeight : ${this.container.scrollHeight} --`, 'background: gray; color: white');

			if(top < this.container.scrollHeight && (this.container.scrollHeight - top) >= this.layout.height/2) {

				//float issue：
				//console.log(`%c -- trigger scrollby --`, 'background: gray; color: white');

				this.scrollBy(0, this.layout.height, true);
			} else {
				next = this.views.last().section.next();
			}

		} else {
			next = this.views.last().section.next();
		}

		if(next) {

			var nextDisplaying = new defer();
			var nextDisplayed = nextDisplaying.promise;

			//keep now section
			this.nowSection = next;

			this.clear();
			// The new section may have a different writing-mode from the old section. Thus, we need to update layout.
			this.updateLayout();

			let forceRight = false;
			if (this.layout.name === "pre-paginated" && this.layout.divisor === 2 && next.properties.includes("page-spread-right")) {
				forceRight = true;
			}

			//檢查是否有後繼頁面
			let flowSection = this.handleNextPrePaginated(forceRight, next, this.add, true);
			this.finalEventTarget = (flowSection) ? flowSection : next;

			//設定目前顯示章節
			if(!this.rendition.settings.isHidden){
				this.book.spine.each((sectionItem) => sectionItem.checkIsNowDisplay(next.index, this.finalEventTarget.index));
			}

			this.append(next, forceRight)
				.then(function(view){
					return this.hooks.afterIframeOnload.trigger(view.contents, this).then(()=>{
						return view;
					});
				}.bind(this))
				.then(function (view) {
					if(view.contents){
						//確認內容最後尺寸已就緒
						return view.contents.allContentOnloadCheck().then(() => {
							this.updateLayout();
							if(this.rendition._layout.name !== "pre-paginated"){
								return this.sleep(this._waitLayoutUpdateTime).then(()=>{
									return view.contents.finalSizeCheck().then(() => {
										return view;
									});
								});
							}else{
								return view.contents.finalSizeCheck().then(() => {
									view.setEmptyPage(view.contents._backgroundSize);
									return view;
								});
							}
						});
					}else{
						return view;
					}
				}.bind(this))
				.then(function(){
					return this.handleNextPrePaginated(forceRight, next, this.append);
				}.bind(this), (err) => {
					nextDisplaying.reject(err);
				})
				.then(function(){

					// Reset position to start for scrolled-doc vertical-rl in default mode
					if (!this.isPaginated &&
						this.settings.axis === "horizontal" &&
						this.settings.direction === "rtl" &&
						this.settings.rtlScrollType === "default") {
						
						this.scrollTo(this.container.scrollWidth, 0, true);
					}
					this.views.show();
					nextDisplaying.resolve();
				}.bind(this));

			return nextDisplayed;
		}


	}

	handlePrevPrePaginated(forceRight, section, action, isPreCheck = false) {
		let flow;
		if (this.layout.name === "pre-paginated" && this.layout.divisor > 1) {
			if (forceRight || section.index === 0 || section.properties.includes("page-spread-center") || section.properties.includes("rendition:page-spread-center") || section.properties.includes("page-spread-center-left") || section.properties.includes("page-spread-center-right")) {
				// First page (cover) and center page should stand alone for pre-paginated books
				return;
			}

			if(this.rendition.settings.direction === "ltr" && (section.properties.includes("page-spread-right") || section.properties.includes("rendition:page-spread-right"))){
				//目前已載入右側頁面
				flow = section.prev();
			}else if(this.rendition.settings.direction === "rtl" && (section.properties.includes("page-spread-left") || section.properties.includes("rendition:page-spread-left"))){
				//目前已載入左側頁面
				flow = section.prev();
			}

			if (flow && !flow.properties.includes("page-spread-center") && !flow.properties.includes("rendition:page-spread-center") && !flow.properties.includes("page-spread-center-left") && !flow.properties.includes("page-spread-center-right")) {
				if(isPreCheck){
					return flow;
				}else{
					//加入判斷, 以排除重複加入後繼頁面的問題
					let isAlreadyAddFlow = false;
					$.each(this.views._views, (index, alreadyAddSection) => {
						if(alreadyAddSection.index == flow.index) {
							isAlreadyAddFlow = true;
							return false;
						}
					});
					if(!isAlreadyAddFlow){
						return action.call(this, flow).then(function(view){
							return this.hooks.afterIframeOnload.trigger(view.contents, this).then(()=>{
								return view;
							});
						}.bind(this)).then(function (view) {
							if(view.contents){
								//確認內容最後尺寸已就緒
								return view.contents.allContentOnloadCheck().then(() => {
									this.updateLayout();
									if(this.rendition._layout.name !== "pre-paginated"){
										return this.sleep(this._waitLayoutUpdateTime).then(()=>{
											return view.contents.finalSizeCheck().then(() => {
												return view;
											});
										});
									}else{
										return view.contents.finalSizeCheck().then(() => {
											view.setEmptyPage(view.contents._backgroundSize);
											return view;
										});
									}
								});
							}else{
								return view;
							}
						}.bind(this));
					}else{
						return;
					}
				}
			}
		
		}else{
			if(isPreCheck){
				return null;
			}
		}
	}

	prev(){
		var prev;
		var left;
		let dir = this.settings.direction;

		if(!this.views.length) return;

		if(this.isPaginated && this.settings.axis === "horizontal" && (!dir || dir === "ltr")) {

			this.scrollLeft = this.container.scrollLeft;

			//android 有翻頁不準的情況, 所以用頁數的方式反推
			//left = this.container.scrollLeft;
			left = this.getPrevFixLeft();

			if(this.rendition._layout.name !== "pre-paginated" && left > 0) {
				this.scrollBy(-this.layout.delta, 0, true);
			} else {
				prev = this.views.first().section.prev();
			}

		} else if (this.isPaginated && this.settings.axis === "horizontal" && dir === "rtl") {

			this.scrollLeft = this.container.scrollLeft;

			if (this.settings.rtlScrollType === "default"){
				left = this.getPrevFixLeft();
				//left = this.container.scrollLeft + this.container.offsetWidth;
				
				if (this.rendition._layout.name !== "pre-paginated" && left < this.container.scrollWidth) {
					this.scrollBy(-this.layout.delta, 0, true);
				} else {
					prev = this.views.first().section.prev();
				}
			}
			else{
				left = this.container.scrollLeft;

				//left = this.getPrevFixLeft();

				if (this.rendition._layout.name !== "pre-paginated" && left < 0) {
					this.scrollBy(-this.layout.delta, 0, true);
				} else {
					prev = this.views.first().section.prev();
				}
			}

		} else if (this.isPaginated && this.settings.axis === "vertical") {

			this.scrollTop = this.container.scrollTop;

			//android 有翻頁不準的情況, 所以用頁數的方式反推
			//let top = this.container.scrollTop;
			let top  = this.getPrevFixTop();

			if(top > 0) {
				this.scrollBy(0, -(this.layout.height), true);
			} else {
				prev = this.views.first().section.prev();
			}

		} else {

			prev = this.views.first().section.prev();

		}

		if(prev) {

			var prevDisplaying = new defer();
			var prevDisplayed = prevDisplaying.promise;

			//keep now section
			this.nowSection = prev;

			this.clear();
			// The new section may have a different writing-mode from the old section. Thus, we need to update layout.
			this.updateLayout();

			let forceRight = false;
			if (this.layout.name === "pre-paginated" && this.layout.divisor === 2 && typeof prev.prev() !== "object") {
				forceRight = true;
			}

			//檢查是否有後繼頁面
			let flowSection = this.handlePrevPrePaginated(forceRight, prev, this.prepend, true);
			this.finalEventTarget = (flowSection) ? flowSection : prev;

			//設定目前顯示章節
			if(!this.rendition.settings.isHidden){
				this.book.spine.each((sectionItem) => sectionItem.checkIsNowDisplay(prev.index, this.finalEventTarget.index));
			}

			this.prepend(prev, forceRight)
				.then(function(view){
					return this.hooks.afterIframeOnload.trigger(view.contents, this).then(()=>{
						return view;
					});
				}.bind(this))
				.then(function (view) {
					if(view.contents){
						//確認內容最後尺寸已就緒
						return view.contents.allContentOnloadCheck().then(() => {
							this.updateLayout();
							if(this.rendition._layout.name !== "pre-paginated"){
								return this.sleep(this._waitLayoutUpdateTime).then(()=>{
									return view.contents.finalSizeCheck().then(() => {
										return view;
									});
								});
							}else{
								return view.contents.finalSizeCheck().then(() => {
									view.setEmptyPage(view.contents._backgroundSize);
									return view;
								});
							}
						});
					}else{
						return view;
					}
				}.bind(this))
				.then(function(){
					return this.handlePrevPrePaginated(forceRight, prev, this.prepend);
				}.bind(this), (err) => {
					prevDisplaying.reject(err);
				})
				.then(function(){
					if(this.isPaginated && this.settings.axis === "horizontal") {
						if (this.settings.direction === "rtl") {
							if (this.settings.rtlScrollType === "default"){
								this.scrollTo(0, 0, true);
							}
							else{
								this.scrollTo((this.container.scrollWidth * -1) + this.layout.delta, 0, true);
							}
						} else {
							this.scrollTo(this.container.scrollWidth - this.layout.delta, 0, true);
						}
					} else if (this.isPaginated && this.settings.axis === "vertical") {
						this.scrollTo(0, this.container.scrollHeight - this.layout.height, true);
					}

					this.views.show();
					prevDisplaying.resolve();
				}.bind(this));

			return prevDisplayed;
		}
	}

	getNextFixLeft(){
		let dir = this.settings.direction, nowPage;
		if(!dir || dir === "ltr"){
			nowPage = Math.round((this.container.scrollLeft + this.layout.delta) / this.layout.delta);
			return this.container.offsetWidth + nowPage * this.layout.delta;
		}else{
			if (this.settings.rtlScrollType === "default"){
				nowPage = Math.round(this.container.scrollLeft / this.layout.delta);
				return nowPage * this.layout.delta;
			}else{
				nowPage = Math.round(Math.abs(this.container.scrollLeft + ( this.layout.delta * -1 )) / this.layout.delta);
				return -nowPage * this.layout.delta;
			}	
		}	
	}

	getPrevFixLeft(){
		let dir = this.settings.direction, nowPage;
		if(!dir || dir === "ltr"){
			nowPage = Math.round(this.container.scrollLeft / this.layout.delta);
			return nowPage * this.layout.delta;
		}else{
			if (this.settings.rtlScrollType === "default"){
				nowPage = Math.round(this.container.scrollLeft / this.layout.delta);
				return this.container.offsetWidth + nowPage * this.layout.delta;
			}else{
				nowPage = Math.round(this.container.scrollLeft / this.layout.delta);
				return nowPage * this.layout.delta;
			}
		}
	}

	getNextFixTop(){
		let nowPage = Math.round((this.container.scrollTop + this.container.offsetHeight) / this.container.offsetHeight);
		return nowPage * this.container.offsetHeight;
	}

	getPrevFixTop(){
		let nowPage = Math.round((this.container.scrollTop + this.container.offsetHeight) / this.container.offsetHeight);
		return (nowPage -1) * this.container.offsetHeight;
	}

	createView(section, forceRight, book, rendition) {
		return new this.View(section, extend(this.viewSettings, { forceRight }), book, rendition);
	}

	add(section, forceRight){
		var view = this.createView(section, forceRight, this.book, this.rendition);

		this.views.append(view);

		// view.on(EVENTS.VIEWS.SHOWN, this.afterDisplayed.bind(this));
		view.onDisplayed = this.afterDisplayed.bind(this);
		view.onResize = this.afterResized.bind(this);

		view.on(EVENTS.VIEWS.AXIS, (axis) => {
			this.updateAxis(axis);
		});

		view.on(EVENTS.VIEWS.WRITING_MODE, (mode) => {
			this.updateWritingMode(mode);
		});

		//加入GET_SECTION_RENDER事件
		view.on(EVENTS.VIEWS.GET_SECTION_RENDER, (section) => {
			this.rendition.loadSection(section);
		});

		return view.display(this.request);
	}

	append(section, forceRight){
		var view = this.createView(section, forceRight, this.book, this.rendition);

		this.views.append(view);

		view.onDisplayed = this.afterDisplayed.bind(this);
		view.onResize = this.afterResized.bind(this);

		view.on(EVENTS.VIEWS.AXIS, (axis) => {
			this.updateAxis(axis);
		});

		view.on(EVENTS.VIEWS.WRITING_MODE, (mode) => {
			this.updateWritingMode(mode);
		});

		//加入GET_SECTION_RENDER事件
		view.on(EVENTS.VIEWS.GET_SECTION_RENDER, (section) => {
			this.rendition.loadSection(section);
		});

		return view.display(this.request);
	}

	prepend(section, forceRight){
		var view = this.createView(section, forceRight, this.book, this.rendition);

		view.on(EVENTS.VIEWS.RESIZED, (bounds) => {
			this.counter(bounds, section);
		});

		this.views.prepend(view);

		view.onDisplayed = this.afterDisplayed.bind(this);
		view.onResize = this.afterResized.bind(this);

		view.on(EVENTS.VIEWS.AXIS, (axis) => {
			this.updateAxis(axis);
		});

		view.on(EVENTS.VIEWS.WRITING_MODE, (mode) => {
			this.updateWritingMode(mode);
		});

		//加入GET_SECTION_RENDER事件
		view.on(EVENTS.VIEWS.GET_SECTION_RENDER, (section) => {
			this.rendition.loadSection(section);
		});


		return view.display(this.request);
	}

	counter(bounds, section){
		if(this.settings.axis === "vertical") {
			this.scrollBy(0, bounds.heightDelta, true);
		} else {
			this.scrollBy(bounds.widthDelta, 0, true);
		}

	}

	updateLayout() {

		if (!this.stage) {
			return;
		}

		this._stageSize = this.stage.size();

		if(!this.isPaginated) {
			this.layout.calculate(this.nowSection, this._stageSize.width, this._stageSize.height);
		} else {
			this.layout.calculate(
				this.nowSection,
				this._stageSize.width,
				this._stageSize.height,
				this.settings.gap
			);

			// Set the look ahead offset for what is visible
			this.settings.offset = this.layout.delta / this.layout.divisor;

			// this.stage.addStyleRules("iframe", [{"margin-right" : this.layout.gap + "px"}]);

		}

		// Set the dimensions for views
		this.viewSettings.width = this.layout.width;
		this.viewSettings.height = this.layout.height;

		this.setLayout(this.layout);
	}

	moveTo(offset, width){

		var distX = 0, distY = 0;

		if(!this.isPaginated) {
			distY = offset.top;
		} else {
			distX = Math.floor(offset.left / this.layout.delta) * this.layout.delta;
			if (distX + this.layout.delta > this.container.scrollWidth) {
				distX = this.container.scrollWidth - this.layout.delta;
			}

			//因直書修正計算模式
			distY = Math.floor(offset.top / this.layout.height) * this.layout.height;

			if (distY + this.layout.height > this.container.scrollHeight) {
				distY = this.container.scrollHeight - this.layout.height;
			}

		}
		if(this.settings.direction === "rtl"){
			/***
				the `floor` function above (L343) is on positive values, so we should add one `layout.delta` 
				to distX or use `Math.ceil` function, or multiply offset.left by -1
				before `Math.floor`
			*/
			distX = distX + this.layout.delta; 
			if(this.settings.rtlScrollType !== "default"){
				distX = distX - width;
			}
		}
		
		this.scrollTo(distX, distY, true);
	}

	setLayout(layout){

		this.viewSettings.layout = layout;

		this.mapping = new ExMapping(layout.props, this.settings.direction, this.settings.axis);

		if(this.views) {

			this.views.forEach(function(view){
				if (view) {
					view.setLayout(layout);
				}
			});

		}

	}

	updateAxis(axis, forceUpdate){

		if (!forceUpdate && axis === this.settings.axis) {
			return;
		}

		this.settings.axis = axis;

		this.stage && this.stage.axis(axis);

		this.viewSettings.axis = axis;

		if (this.mapping) {
			this.mapping = new ExMapping(this.layout.props, this.settings.direction, this.settings.axis);
		}

		if (this.layout) {
			let nowSpread = (this.layout.props.spread) ? "auto" : "none";
			if (axis === "vertical") {
				this.layout.spread(`vertical_${nowSpread}`);
			} else {
				this.layout.spread(nowSpread);
			}
		}

	}

	currentLocation(){
		//this.updateLayout(); 
		if (this.isPaginated && this.settings.axis === "horizontal") {
			this.location = this.paginatedLocation();
		} else {
			this.location = this.scrolledLocation();
		}
		return this.location;
	}

	getSpineAllLocation(){
		//this.updateLayout();
		if (this.isPaginated && this.settings.axis === "horizontal") {
			this.location = this.paginatedAllLocation();
		} else {
			this.location = this.scrolledAllLocation();
		}
		return this.location;
	}

	paginatedAllLocation(){
		let visible = this.visible();
		let container = this.container.getBoundingClientRect();

		let left = 0;
		let used = 0;

		if(this.settings.fullsize) {
			left = window.scrollX;
		}

		let sections = visible.map((view) => {
			let {index, href} = view.section;
			let offset;
			let position = view.position();
			let width = view.width();
			let totalPages = this.layout.count(width).pages;

			// Find mapping
			let start;
			let end;
			let pageWidth;
			let stopPos;

			if (this.settings.direction === "rtl") {
				offset = container.right - left;
				pageWidth = Math.min(Math.abs(offset - position.left), this.layout.width) - used;
				pageWidth = (pageWidth < this.layout.width) ? this.layout.width : pageWidth;
				stopPos = pageWidth;
			} else {
				offset = container.left + left;
				pageWidth = Math.min(position.right - offset, this.layout.width) - used;
				pageWidth = (pageWidth < this.layout.width) ? this.layout.width : pageWidth;
				stopPos = pageWidth;
			}

			let totalCfi = [], startPage, endPage;
			let framePerPage = this.rendition._layout.divisor;
			let totalFrame = Math.ceil(totalPages/framePerPage);
			
			for(let frame = 0; frame < totalFrame; frame++){
				let pages = [];
				if (this.settings.direction === "rtl") {
					start = (totalFrame - frame - 1)*stopPos;
					end = (totalFrame - frame)*stopPos;
				}else{
					start = frame*stopPos;
					end = (frame+1)*stopPos;
				}
				startPage = Math.floor(start / this.layout.pageWidth);
			    endPage = Math.floor(end / this.layout.pageWidth);
				// start page should not be negative
				if (startPage < 0) {
					startPage = 0;
					endPage = endPage + 1;
				}
				// Reverse page counts for rtl
				if (this.settings.direction === "rtl") {
					let tempStartPage = startPage;
					startPage = totalPages - endPage;
					endPage = totalPages - tempStartPage;
				}

				for (var i = startPage + 1; i <= endPage; i++) {
					let pg = i;
					pages.push(pg);
				}

				totalCfi.push({
					page: pages,
					mapping: this.mapping.page(view.contents, view.section.cfiBase, start, end)
				});

			}

			return {
				index,
				href,
				totalPages,
				totalCfi
			};
		});

		return sections;
	}

	scrolledAllLocation() {
		let visible = this.visible();
		let container = this.container.getBoundingClientRect();
		let isViewportScale = (window.visualViewport.scale.toFixed(2) > 1);
		let pageHeight = (isViewportScale) ? container.height : (container.height < window.innerHeight) ? container.height : window.innerHeight;
		let pageWidth = (isViewportScale) ? container.width : (container.width < window.innerWidth) ? container.width : window.innerWidth;
		let vertical = (this.settings.axis === "vertical");
		let rtl =  (this.settings.direction === "rtl"); 
			
		let offset = 0;
		let used = 0;

		if(this.settings.fullsize) {
			offset = vertical ? window.scrollY : window.scrollX;
		}

		let sections = visible.map((view) => {
			let {index, href} = view.section;
			let position = view.position();
			let width = view.width();
			let height = view.height();

			let startPos;
			let endPos;
			let stopPos;
			let totalPages;

			if (vertical) {
				totalPages = this.layout.count(height, pageHeight).pages;
				stopPos = pageHeight;
			} else {
				totalPages = this.layout.count(width, pageWidth).pages;
				stopPos = pageWidth;
			}
			let totalCfi = [], currPage, endPage;
			for(let page = 1; page <= totalPages; page++){
				let pages = [];
				startPos = (page-1)*stopPos;
				endPos = page*stopPos;

				currPage = endPage = Math.ceil(startPos / stopPos);
				if (this.settings.direction === "rtl" && !vertical) {
					let tempStartPage = currPage;
					currPage = totalPages - endPage;
					endPage = totalPages - tempStartPage;
				}

				let pg;
				for (var i = currPage; i <= endPage; i++) {
					pg = i + 1;
					pages.push(pg);
				}

				totalCfi.push({
					page: pages,
					mapping: this.mapping.page(view.contents, view.section.cfiBase, startPos, endPos)
				});
			}

			return {
				index,
				href,
				totalPages,
				totalCfi
			};
		});

		return sections;
	}

	paginatedLocation(){
		let visible = this.visible();
		let container = this.container.getBoundingClientRect();

		let left = 0;
		let used = 0;

		if(this.settings.fullsize) {
			left = window.scrollX;
		}

		let sections = visible.map((view) => {
			let {index, href} = view.section;
			let offset;
			let position = view.position();
			let width = view.width();

			// Find mapping
			let start;
			let end;
			let pageWidth;

			if (this.settings.direction === "rtl") {
				offset = container.right - left;
				pageWidth = Math.min(Math.abs(offset - position.left), this.layout.width) - used;
				pageWidth = (pageWidth < this.layout.width) ? this.layout.width : pageWidth;
				end = position.width - (position.right - offset) - used;
				start = end - pageWidth;

				//android 有翻頁不準的情況, 所以用頁數的方式反推
				end = Math.round(end / pageWidth) * pageWidth;
				start = end - pageWidth;
			} else {
				offset = container.left + left;
				pageWidth = Math.min(position.right - offset, this.layout.width) - used;
				pageWidth = (pageWidth < this.layout.width) ? this.layout.width : pageWidth;
				start = offset - position.left + used;
				end = start + pageWidth;

				//android 有翻頁不準的情況, 所以用頁數的方式反推
				end = Math.round(end / pageWidth) * pageWidth;
				start = end - pageWidth;
			}

			used += pageWidth;

			let mapping = this.mapping.page(view.contents, view.section.cfiBase, start, end);

			let totalPages = this.layout.count(width).pages;
			let startPage = Math.floor(start / this.layout.pageWidth);
			let pages = [];
			let endPage = Math.floor(end / this.layout.pageWidth);


			//float issue：
			// float/pageWidth 取floor後可能永遠算不到最後一頁-> 無法得到atEnd
			//console.log(`relocated calc : start:${start}, end:${end}, pageWidth:${pageWidth}, total width: ${width}`);
			
			// start page should not be negative
			if (startPage < 0) {
				startPage = 0;
				endPage = endPage + 1;
			}

			// Reverse page counts for rtl
			if (this.settings.direction === "rtl") {
				let tempStartPage = startPage;
				startPage = totalPages - endPage;
				endPage = totalPages - tempStartPage;
			}

			for (var i = startPage + 1; i <= endPage; i++) {
				let pg = i;
				pages.push(pg);
			}

			return {
				index,
				href,
				pages,
				totalPages,
				mapping
			};
		});

		return sections;
	}

	center(){
		var container = this.bounds();
		var views = this.views.displayed();
		var viewsLength = views.length;
		var center = [];
		var isCenter;
		var view;

		for (var i = 0; i < viewsLength; i++) {
			view = views[i];
			isCenter = this.isCenter(view, container);

			if(isCenter === true) {
				center.push(view);
			}

		}
		return center;
	}

	isCenter(view, _container){
		var position = view.position();
		var container = _container || this.bounds();
		//固定版永遠以垂直方向計算
		var isHorizontal = (this.book.package.metadata.layout === "pre-paginated") ? false : this.settings.axis === "horizontal" ;
		var center = (isHorizontal) ? container.width/2 : container.height/2;

		if(isHorizontal &&
            position.right > center &&
            position.left < center) {
            return true;
        } else if(!isHorizontal &&
            position.bottom > center &&
            position.top < center) {
            return true;
        }

		return false;
	}

	isVisible(view, offsetPrev, offsetNext, _container){
		var position = view.position();
		var container = _container || this.bounds();
		//固定版永遠以垂直方向計算
		var isHorizontal = (this.book.package.metadata.layout === "pre-paginated") ? false : this.settings.axis === "horizontal" ;

		if(isHorizontal &&
			position.right > container.left - offsetPrev &&
			position.left < container.right + offsetNext) {

			return true;

		} else if(!isHorizontal &&
			position.bottom > container.top - offsetPrev &&
			position.top < container.bottom + offsetNext) {

			return true;
		}

		return false;

	}

	centerLocation() {
		let center = this.center();
		let container = this.container.getBoundingClientRect();
		let pageHeight = (container.height < window.innerHeight) ? container.height : window.innerHeight;
		let pageWidth = (container.width < window.innerWidth) ? container.width : window.innerWidth;
		let vertical = (this.book.package.metadata.layout === "pre-paginated" || this.settings.axis === "vertical");
		
			
		let offset = 0;
		let used = 0;

		if(this.settings.fullsize) {
			offset = vertical ? window.scrollY : window.scrollX;
		}

		let centerSections = center.map((view) => {
			let {index, href} = view.section;
			let position = view.position();
			let width = view.width();
			let height = view.height();
	
			let startPos;
			let endPos;
			let stopPos;
			let totalPages;
	
			if (vertical) {
				startPos = offset + container.top - position.top + used;
				endPos = startPos + pageHeight - used;
				totalPages = this.layout.count(height, pageHeight).pages;
				stopPos = pageHeight;
			} else {
				startPos = offset + container.left - position.left + used;
				endPos = startPos + pageWidth - used;
				totalPages = this.layout.count(width, pageWidth).pages;
				stopPos = pageWidth;
			}
	
			let currPage = Math.ceil(startPos / stopPos);
			let pages = [];
			//修正為startPos
			let endPage = Math.ceil(startPos / stopPos);
	
			// Reverse page counts for horizontal rtl
			if (this.settings.direction === "rtl" && !vertical) {
				let tempStartPage = currPage;
				currPage = totalPages - endPage;
				endPage = totalPages - tempStartPage;
			}
	
			pages = [];
			for (var i = currPage; i <= endPage; i++) {
				let pg = i + 1;
				pages.push(pg);
			}
	
			let mapping = this.mapping.page(view.contents, view.section.cfiBase, startPos, endPos);
	
			return {
				index,
				href,
				pages,
				totalPages,
				mapping
			};
		});
		return centerSections;
	}

	currentSelection(startPos, endPos){

		let visible = this.visible();

		let sections = visible.map((view) => {
			
			let selection_mapping = this.mapping.selection(view.contents, view.section.cfiBase, startPos, endPos);

			return selection_mapping;
		});

		return sections[0];
	}

	scrolledLocation() {
		let visible = this.visible();
		let container = this.container.getBoundingClientRect();
		let isViewportScale = (window.visualViewport.scale.toFixed(2) > 1);
		let pageHeight = (isViewportScale) ? container.height : (container.height < window.innerHeight) ? container.height : window.innerHeight;
		let pageWidth = (isViewportScale) ? container.width : (container.width < window.innerWidth) ? container.width : window.innerWidth;
		let vertical = (this.book.package.metadata.layout === "pre-paginated" || this.settings.axis === "vertical");
		
		let offset = 0;
		let used = 0;

		if(this.settings.fullsize) {
			offset = vertical ? window.scrollY : window.scrollX;
		}

		let sections = visible.map((view) => {
			let {index, href} = view.section;
			let position = view.position();
			let width = view.width();
			let height = view.height();

			let startPos;
			let endPos;
			let stopPos;
			let ad_startPos;
			let ad_endPos;
			let ad_stopPos;
			let totalPages;

			if (vertical) {
				startPos = offset + container.top - position.top + used;
				ad_startPos = Math.round(startPos);
				endPos = startPos + pageHeight - used;
				ad_endPos = Math.round(endPos);
				totalPages = this.layout.count(height, pageHeight).pages;
				stopPos = pageHeight;
				ad_stopPos = Math.round(stopPos);
			} else {
				startPos = offset + container.left - position.left + used;
				ad_startPos = Math.round(startPos);
				endPos = startPos + pageWidth - used;
				ad_endPos = Math.round(endPos);
				totalPages = this.layout.count(width, pageWidth).pages;
				stopPos = pageWidth;
				ad_stopPos = Math.round(stopPos);
			}

			//let currPage = Math.ceil(startPos / stopPos);
			let currPage = ((Math.ceil(ad_startPos / ad_stopPos) - ad_startPos / ad_stopPos) < 0.5) ? Math.ceil( ad_startPos / ad_stopPos ) : Math.floor( ad_startPos / ad_stopPos );
			let pages = [];
			//let endPage = Math.ceil(endPos / stopPos);
			let endPage = ((Math.ceil(ad_endPos / ad_stopPos) - ad_endPos / ad_stopPos) < 0.5) ? Math.ceil( ad_endPos / ad_stopPos ) - 1 : Math.floor( ad_endPos / ad_stopPos ) - 1;
			// Reverse page counts for horizontal rtl
			if (this.settings.direction === "rtl" && !vertical) {
				let tempStartPage = currPage;
				currPage = totalPages - endPage;
				endPage = totalPages - tempStartPage;
			}
			//console.log("-----------------------");
			//console.log("currPage:",currPage, "endPage:",endPage);
			//console.log("startCheck:",Math.ceil(startPos / stopPos) - startPos / stopPos, "endCheck:",Math.ceil(endPos / stopPos) - endPos / stopPos);
			//console.log("startCount:",startPos / stopPos, "endCount:", endPos / stopPos);
			//console.log("startPos:",startPos, "endPos:",endPos, "stopPos:", stopPos);

			pages = [];
			for (var i = currPage; i <= endPage; i++) {
				let pg = i + 1;
				pages.push(pg);
			}

			let mapping = this.mapping.page(view.contents, view.section.cfiBase, startPos, endPos);

			return {
				index,
				href,
				pages,
				totalPages,
				mapping
			};
		});

		return sections;
	}

	removeEventListeners(){
		var scroller;

		if(!this.settings.fullsize) {
			scroller = this.container;
		} else {
			scroller = window;
		}
		if(scroller){
			scroller.removeEventListener("scroll", this._onScroll);
		}
		this._onScroll = undefined;
		
	}

	destroy(){
		clearTimeout(this.orientationTimeout);
		clearTimeout(this.resizeTimeout);
		clearTimeout(this.afterScrolled);

		this.clear();

		this.removeEventListeners();

		if(this.stage){
			this.stage.destroy();
		}

		this.rendered = false;

		this.q.clear();
		this.q = undefined;

		//移除顯示器
		this.rendition = undefined;

		//移除書籍
		this.book = undefined;

		clearTimeout(this._resizeTimeout);
		this._resizeTimeout = undefined;
	}

}

export default ExDefaultViewManager;